/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getICD10Procedures } from 'app/entities/icd-10-procedure/icd-10-procedure.reducer';
import { getEntities as getICD10Diagnoses } from 'app/entities/icd-10-diagnosis/icd-10-diagnosis.reducer';
import { getEntities as getAppointments } from 'app/entities/appointments/appointments.reducer';
import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getHospitals } from 'app/entities/hospital/hospital.reducer';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';
import { AdmissionType } from 'app/shared/model/enumerations/admission-type.model';
import { createEntity, getEntity, reset, updateEntity } from './admission-advice.reducer';

export const AdmissionAdviceUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const iCD10Procedures = useAppSelector(state => state.iCD10Procedure.entities);
  const iCD10Diagnoses = useAppSelector(state => state.iCD10Diagnosis.entities);
  const appointments = useAppSelector(state => state.appointments.entities);
  const doctors = useAppSelector(state => state.doctor.entities);
  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const hospitals = useAppSelector(state => state.hospital.entities);
  const admissionAdviceEntity = useAppSelector(state => state.admissionAdvice.entity);
  const loading = useAppSelector(state => state.admissionAdvice.loading);
  const updating = useAppSelector(state => state.admissionAdvice.updating);
  const updateSuccess = useAppSelector(state => state.admissionAdvice.updateSuccess);
  const addedByTypeValues = Object.keys(AddedByType);
  const admissionTypeValues = Object.keys(AdmissionType);

  const handleClose = () => {
    navigate(`/admission-advice${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getICD10Procedures({}));
    dispatch(getICD10Diagnoses({}));
    dispatch(getAppointments({}));
    dispatch(getDoctors({}));
    dispatch(getGlucoUsers({}));
    dispatch(getHospitals({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...admissionAdviceEntity,
      ...values,
      proposedProcedure: iCD10Procedures.find(it => it.id.toString() === values.proposedProcedure?.toString()),
      diagnosis: iCD10Diagnoses.find(it => it.id.toString() === values.diagnosis?.toString()),
      appointment: appointments.find(it => it.id.toString() === values.appointment?.toString()),
      advicedBy: doctors.find(it => it.id.toString() === values.advicedBy?.toString()),
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
      admitAt: hospitals.find(it => it.id.toString() === values.admitAt?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          modifiedByType: 'DOCTOR',
          type: 'REGULAR',
          ...admissionAdviceEntity,
          proposedProcedure: admissionAdviceEntity?.proposedProcedure?.id,
          diagnosis: admissionAdviceEntity?.diagnosis?.id,
          appointment: admissionAdviceEntity?.appointment?.id,
          advicedBy: admissionAdviceEntity?.advicedBy?.id,
          patient: admissionAdviceEntity?.patient?.id,
          admitAt: admissionAdviceEntity?.admitAt?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.admissionAdvice.home.createOrEditLabel" data-cy="AdmissionAdviceCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.admissionAdvice.home.createOrEditLabel">Create or edit a AdmissionAdvice</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="admission-advice-id"
                  label={translate('tinyMedicRestApp.admissionAdvice.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.admissionAdvice.procedureSNId')}
                id="admission-advice-procedureSNId"
                name="procedureSNId"
                data-cy="procedureSNId"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.admissionAdvice.procedureSNText')}
                id="admission-advice-procedureSNText"
                name="procedureSNText"
                data-cy="procedureSNText"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.admissionAdvice.adviseNotes')}
                id="admission-advice-adviseNotes"
                name="adviseNotes"
                data-cy="adviseNotes"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.admissionAdvice.instructions')}
                id="admission-advice-instructions"
                name="instructions"
                data-cy="instructions"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.admissionAdvice.snomedConceptId')}
                id="admission-advice-snomedConceptId"
                name="snomedConceptId"
                data-cy="snomedConceptId"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.admissionAdvice.snomedConceptText')}
                id="admission-advice-snomedConceptText"
                name="snomedConceptText"
                data-cy="snomedConceptText"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.admissionAdvice.active')}
                id="admission-advice-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.admissionAdvice.timestampentry')}
                id="admission-advice-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.admissionAdvice.microSec')}
                id="admission-advice-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.admissionAdvice.lastupdated')}
                id="admission-advice-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.admissionAdvice.cursor')}
                id="admission-advice-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.admissionAdvice.fulfilled')}
                id="admission-advice-fulfilled"
                name="fulfilled"
                data-cy="fulfilled"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.admissionAdvice.emergency')}
                id="admission-advice-emergency"
                name="emergency"
                data-cy="emergency"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.admissionAdvice.highRisk')}
                id="admission-advice-highRisk"
                name="highRisk"
                data-cy="highRisk"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.admissionAdvice.modifiedByType')}
                id="admission-advice-modifiedByType"
                name="modifiedByType"
                data-cy="modifiedByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.admissionAdvice.modifiedByID')}
                id="admission-advice-modifiedByID"
                name="modifiedByID"
                data-cy="modifiedByID"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.admissionAdvice.emAdmissionId')}
                id="admission-advice-emAdmissionId"
                name="emAdmissionId"
                data-cy="emAdmissionId"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.admissionAdvice.type')}
                id="admission-advice-type"
                name="type"
                data-cy="type"
                type="select"
              >
                {admissionTypeValues.map(admissionType => (
                  <option value={admissionType} key={admissionType}>
                    {translate(`tinyMedicRestApp.AdmissionType.${admissionType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                id="admission-advice-proposedProcedure"
                name="proposedProcedure"
                data-cy="proposedProcedure"
                label={translate('tinyMedicRestApp.admissionAdvice.proposedProcedure')}
                type="select"
              >
                <option value="" key="0" />
                {iCD10Procedures
                  ? iCD10Procedures.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="admission-advice-diagnosis"
                name="diagnosis"
                data-cy="diagnosis"
                label={translate('tinyMedicRestApp.admissionAdvice.diagnosis')}
                type="select"
                required
              >
                <option value="" key="0" />
                {iCD10Diagnoses
                  ? iCD10Diagnoses.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="admission-advice-appointment"
                name="appointment"
                data-cy="appointment"
                label={translate('tinyMedicRestApp.admissionAdvice.appointment')}
                type="select"
              >
                <option value="" key="0" />
                {appointments
                  ? appointments.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="admission-advice-advicedBy"
                name="advicedBy"
                data-cy="advicedBy"
                label={translate('tinyMedicRestApp.admissionAdvice.advicedBy')}
                type="select"
                required
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="admission-advice-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.admissionAdvice.patient')}
                type="select"
                required
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="admission-advice-admitAt"
                name="admitAt"
                data-cy="admitAt"
                label={translate('tinyMedicRestApp.admissionAdvice.admitAt')}
                type="select"
                required
              >
                <option value="" key="0" />
                {hospitals
                  ? hospitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/admission-advice" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default AdmissionAdviceUpdate;
